import {createRouter, createWebHashHistory} from 'vue-router';
// Common
import UserLogin from './components/login.vue';
// admin
// import AdminPanel from './components/admin/admin.vue';
import CorporationList from './components/admin/corporation-list.vue';
import UserList from './components/admin/user-list.vue';
import BoxList from './components/admin/box-list.vue';
// User
import DashBoard from './components/user/dashboard.vue';
import BmsStateList from './components/user/bms-state-list.vue';
// import ApiTest from './components/api-test.vue';
import UserStore from './stores/user.js';

import {notify} from './assets/js/utils.js';

const common_routes = [
    {path: '/', name: 'home', component: UserLogin, label: '首页'},
    {path: '/login', name: 'login', role: 'anyone', component: UserLogin, label: '登录'},
];

const USER_DEFAULT_PAGE = 'dashboard';

const user_routes = [
    // 动态字段以冒号开始
    {
        path: '/user/',
        name: 'user',
        menu: false,
        role: 'user',
        redirect: `/user/${USER_DEFAULT_PAGE}`,
    },
    {
        path: '/user/dashboard',
        name: 'dashboard',
        component: DashBoard,
        label: '用户首页',
        menu: true,
        role: 'user',
    },
    {
        path: '/user/bms-state-list',
        name: 'bmsStateList',
        component: BmsStateList,
        label: 'BMS状态列表',
        menu: true,
        role: 'user',
    },

];

const admin_routes = [
    {
        path: '/admin/',
        name: 'admin',
        label: '系统管理',
        menu: false,
        role: 'admin',
        redirect: '/admin/corporation-list',
    },
    {
        path: '/admin/corporation-list',
        name: 'corporationList',
        component: CorporationList,
        label: '企业管理',
        menu: true,
        role: 'admin',
    },
    {
        path: '/admin/user-list',
        name: 'userList',
        component: UserList,
        label: '账号管理',
        menu: true,
        role: 'admin',
    },
    {
        path: '/admin/box-list',
        name: 'boxList',
        component: BoxList,
        label: '设备管理',
        menu: true,
        role: 'admin',
    },
];

const routes = [...common_routes, ...user_routes, ...admin_routes];

function get_menu_routes() {
    const userstore = UserStore();
    return routes.filter(
        x => x.menu && (userstore.is_admin || x.role === '*' || userstore.has_role(x.role ?? x.name)),
    );
}

function get_admin_routes() {
    const userstore = UserStore();
    return admin_routes.filter(
        x => x.menu && (userstore.is_admin || userstore.has_role(x.role ?? x.name)),
    );
}

function get_user_routes() {
    const userstore = UserStore();
    return user_routes.filter(
        x => x.menu && (x.role === '*' || userstore.has_role(x.role ?? x.name)),
    );
}

function get_route(name) {
    return routes.find(x => x.name === name);
}

const router = createRouter({
    // 4. 内部提供了 history 模式的实现。为了简单起见，我们在这里使用 hash 模式。
    history: createWebHashHistory(),
    routes, // `routes: routes` 的缩写
});

router.beforeEach(async (to, _from) => {
    const userstore = UserStore();
    // load user
    if (!userstore.user) await userstore.load();
    // permissions
    if (userstore.is_logged) {
        // 已登录
        if (to.name === 'home') {
            return userstore.is_admin ? get_route('admin') : get_route('dashboard');
        } else {
            const rolename = get_route(to.name)?.role;
            if (rolename && !userstore.user?.roles?.some(role => role.name === rolename)) {
                notify('warning', `权限不足！${to.path}`);
                return get_route('home');
            }
        }
    } else {
        // 未登录
        const route = get_route(to.name);
        if (route?.role === 'anyone') return;
        if (!userstore.user && to.name !== 'login') return {name: 'login'};
    }
});

export default router;
export {get_menu_routes, get_admin_routes, get_user_routes, routes, get_route};
